import React, { useEffect, useState } from "react";
import uploadImage from "../../../../assets/upload-product-image-frame-temp.svg";
import defaultImage from "../../../../assets/default-add-product-image.png";
import { UploadImageContainerPropsType } from "../../../../constants/interface";
import {
  fileToBase64,
  formatBase64Image,
  handleImageVerification,
} from "../../../../shared/utility";
import { toast } from "react-toastify";
import trash from "../../../../assets/trash-bin.svg";
import { useDispatch } from "react-redux";
import { addToDeletedImages,} from "../../../../store/actions/products";
import { DELETE_IMAGE_ACTION_TYPES } from "../../../../constants/constants";
import { useTranslation } from "react-i18next";

const UploadImageContainer: React.FC<UploadImageContainerPropsType> = (
  props
) => {
  const { setFieldValue, productImages, uploadedImages, } = props;
  
  const dispatch: any = useDispatch();

  const [totalImages, setTotalImages] = useState<number>(0);
  const {t} = useTranslation();

  const handleUploadImage = async (event: any) => {
    try{
      const file: any = await fileToBase64(event.target.files[0]);
      
      if(!handleImageVerification(file)){
        toast.warn(t("Notification.WARNING.UPLOAD_ONLY_IMAGES"));
        return;
      }
      if(totalImages >= 10) {
        toast.warning(t("Notification.WARNING.UPLOAD_IMAGE_MAX_LIMIT"));
        return;
      }
      if(file && uploadedImages){   
        uploadedImages?.push(file.replace(/^data:image\/(.*);base64,/, ""));
        setFieldValue("uploadedImages",[...uploadedImages]);
      }
    } catch(error:any){
      console.log(error);
      typeof error === "string" && toast.error(error);
    }
  };

  const handelDeleteImage = async (index: any, imageId: any, type: string) => {
    if(type === DELETE_IMAGE_ACTION_TYPES.PRODUCT_IMAGES){
      const tempObj = {...productImages};
      delete tempObj[imageId];
      setFieldValue("productImages",tempObj);

      dispatch(addToDeletedImages(imageId));
    }else if(type === DELETE_IMAGE_ACTION_TYPES.UPLOADED_IMAGES && uploadedImages){
      const tempArr = [...uploadedImages];
      tempArr?.splice(index,1);
      setFieldValue("uploadedImages",tempArr);
    }
  };

  useEffect(()=>{
    setTotalImages((productImages ? (Object.keys(productImages)?.length) : 0) + (uploadedImages?.length || 0));
  },[productImages, uploadedImages]);

  return (
    <div className="flex flex-col gap-5 w-full md:w-[38%] max-w-lg flex-1">
      <div className="flex items-center justify-center border-dashed btn-file p-10 cursor-pointer max-w-[30rem] ">
        <div className="grid gap-4">
          <img src={uploadImage} alt="upload" className="cursor-pointer m-auto mb-4" />
          <p className="text-xl font-medium text-center">{t("add_edit_product_2")}</p>
          <p className="text-sm text-grey-9E text-center">{t("add_edit_product_3")}</p>
        </div>
        <input
          title="add-product"
          type="file"
          accept=".png,.jpg,.jpeg"
          onChange={handleUploadImage}
        />
      </div>
      <div className="flex gap-5 py-2 w-full overflow-x-auto">
        { 
        productImages &&
          Object.keys(productImages)?.map((item:any, index:number) => (
            <div className="relative w-[105px] h-[105px] min-h-[105px] min-w-[105px]">
              <img
                src={formatBase64Image(productImages[item]) || defaultImage}
                alt="add"
                className="w-full h-full object-fill rounded-lg"
              />
              {productImages[item] && (
                <img
                  src={trash}
                  alt="trash"
                  className="absolute top-1 right-1 cursor-pointer"
                  onClick={() => handelDeleteImage(index, item , DELETE_IMAGE_ACTION_TYPES.PRODUCT_IMAGES)}
                />
              )}
            </div>
          ))}
          {
            uploadedImages?.map((item, index)=>(
              <div className="relative w-[105px] h-[105px] min-h-[105px] min-w-[105px]">
              <img
                src={formatBase64Image(item) || defaultImage}
                alt="add"
                className="w-full h-full object-fill rounded-lg"
              />
              {item && (
                <img
                  src={trash}
                  alt="trash"
                  className="absolute top-1 right-1 cursor-pointer"
                  onClick={() => handelDeleteImage(index, item, DELETE_IMAGE_ACTION_TYPES.UPLOADED_IMAGES)}
                />
              )}             
            </div>
            ))
          }
          { 
          Array.from({length: 4 - totalImages}).map(() => (
            <div className="relative w-[105px] h-[105px] min-h-[105px] min-w-[105px]">
              <img
                src={defaultImage}
                alt="add"
                className="w-full h-full object-fill rounded-lg"
              />
            </div>
          ))}
      </div>
    </div>
  );
};

export default UploadImageContainer;
